import BaseView from '../../../js/base-view';

import PLACEHOLDERS from './placeholder.json';

const FORMATS = {
	medium: { minvw: 0, maxvw: 800 },
	large: { minvw: 0, maxvw: 800 },
	leader: { minvw: 800, maxvw: 1200 },
	bill: { minvw: 1200, maxvw: Number.MAX_SAFE_INTEGER },
};

export default class advertising extends BaseView {
	/**
	 * Entrypoint
	 */
	init() {
		this.props = this.getProps();

		if (! this.props.formats) {
			return;
		}

		this.config = {
			observer: {
				attributes: false,
				childList: true,
				subtree: false
			}
		};

		this.refs = {
			zone: this.el.querySelector('.advertising__zone'),
		};

		this.state = {
			format: this.getFormatForDevice(),
			adLoaded: false,
		};

		// attach events
		this.bindEvents();

		this.loadAd();
	}

	/**
	 * Bind component's events
	 */
	bindEvents() {
		this.on('resize', this.maybeLoadAd.bind(this));

		if (this.props.revive) {
			this.observer = new MutationObserver(this.adZoneMutation.bind(this))
		}
	}

	adZoneMutation(mutationsList) {
		for(const mutation of mutationsList) {
			if (mutation.type === 'childList' && mutation.addedNodes && mutation.addedNodes[0] && mutation.addedNodes[0].dataset.reviveLoaded && mutation.addedNodes[0].dataset.reviveLoaded === '1') {
				this.adLoaded();
				this.observer.disconnect();
			}
		}
	};

	getProps() {
		const props = {
			showPlaceholders: this.el.hasAttribute('data-show-placeholder'),
		};

		try {
			const formats = JSON.parse(this.el.dataset.formats);
			props.formats = Object
				.entries(formats) // desktop || mobile
				.reduce((obj, [format, attrs]) => {
					// eslint-disable-next-line no-param-reassign
					obj[ format ] = { ...FORMATS[ attrs.size ], ...attrs };
					return obj;
				}, {});

			if (this.el.hasAttribute('data-revive-id')) {
				const reviveId = this.el.getAttribute('data-revive-id');

				if (typeof window.reviveAsync !== 'undefined' && typeof window.reviveAsync[ reviveId ] !== 'undefined') {
					props.reviveId = reviveId;
					props.revive = window.reviveAsync[ reviveId ];
				}
			}
		}
		catch (e) {
			console.error('Invalid ad zones attribute');
		}

		return props;
	}

	getFormatForDevice() {
		let nextFormat = false;
		const vw = this.viewport.getCurrentWidth();

		for (const [format, attrs] of Object.entries(this.props.formats)) {
			if (attrs.minvw <= vw && vw < attrs.maxvw) {
				nextFormat = format;
			}
		}

		return nextFormat;
	}

	maybeLoadAd() {
		const format = this.getFormatForDevice();
		if (this.state.format !== format) {
			this.state.format = format;
			this.loadAd();
		}
	}

	loadAd() {
		this.el.classList.add('is-empty');
		this.state.adLoaded = false;
		this.clearZone();

		if (this.props.showPlaceholders) this.loadPlaceholder();
		else if (this.props.revive) this.loadReviveAd();
	}

	adLoaded() {
		// If there is actually an ad loaded (should have an anchor <a> nested)
		const hasAd = this.props.showPlaceholders || (this.refs.zone.querySelector('a') !== null);
		// Display the zone
		if (hasAd) this.el.classList.remove('is-empty');

		// Send a custom event 🤷‍♂️ maybe someone is listening 👽
		this.trigger((hasAd ? 'ad:loaded' : 'ad:empty'), null, false);

		this.state.adLoaded = true;
	}

	loadPlaceholder() {
		const img = document.createElement('img');
		img.setAttribute('style', 'display: block; max-width: 100%;');
		this.refs.zone.appendChild(img);
		this.refs.placeholderImg = img;

		const adLoaded = () => {
			img.removeEventListener('load', adLoaded);
			this.adLoaded();
		};
		img.addEventListener('load', adLoaded);

		const { size } = this.props.formats[this.state.format];
		img.src = `${ PLACEHOLDERS.URL }${ PLACEHOLDERS.FORMATS[ size ].url }`;
	}

	loadReviveAd() {
		this.clearZone();
		const { id } = this.props.formats[this.state.format];
		this.refs.zone.innerHTML = `<ins data-revive-zoneid="${ id }" data-revive-id="${ this.props.reviveId }"></ins>`;

		this.observer.observe(this.refs.zone, this.config.observer);
		this.props.revive.refresh();
	}

	clearZone() {
		while (this.refs.zone.lastElementChild) {
			this.refs.zone.removeChild(this.refs.zone.lastElementChild);
		}
	}

	beforeDestroy() {
		this.observer.disconnect();
	}
}
